import TextOnlyPreview from '../Text/TextOnlyPreview';

type FeedbackInputPreviewProps = {
  value: string;
  title?: string;
  style: any;
  onSelect: (a: string) => void;
};
const FeedbackInputPreview = ({
  value,
  title,
  style,
  onSelect,
}: FeedbackInputPreviewProps) => {
  return (
    <div className="" id="feedback" style={style}>
      {title && <TextOnlyPreview textContent={title} />}
      <div className="flex justify-center gap-4 h-16 mt-2">
        <div
          className={`rounded-full cursor-pointer ${
            value === 'YES' && 'outline-2 outline outline-[#686de0]'
          }`}
          onClick={() => onSelect('YES')}
        >
          <img
            src="https://rhym.s3.ap-south-1.amazonaws.com/website_assets/static/images/icon/like.png"
            className="h-full w-auto"
            alt=""
          />
        </div>
        <div
          className={`rounded-full cursor-pointer ${
            value === 'NO' && 'outline-2 outline outline-[#686de0]'
          }`}
          onClick={() => onSelect('NO')}
        >
          <img
            className="h-full w-auto"
            src="https://rhym.s3.ap-south-1.amazonaws.com/website_assets/static/images/icon/dislike.png"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default FeedbackInputPreview;
